import { render } from "./RecurrenceOptions.vue?vue&type=template&id=56b5a927&scoped=true&ts=true"
import script from "./RecurrenceOptions.vue?vue&type=script&lang=ts"
export * from "./RecurrenceOptions.vue?vue&type=script&lang=ts"

import "./RecurrenceOptions.vue?vue&type=style&index=0&id=56b5a927&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b5a927"]])

export default __exports__